// Customer gallery: carousel controls plus click-to-play.
//
// External videos are not embedded until played — the iframe is created on
// click — so a page full of unplayed cards costs nothing but its posters.

function initGallery(root) {
  if (root.dataset.cgalInit) return;
  root.dataset.cgalInit = '1';

  const track = root.querySelector('[data-cgal-track]');
  if (!track) return;

  const prev = root.querySelector('[data-cgal-prev]');
  const next = root.querySelector('[data-cgal-next]');
  const thumb = root.querySelector('[data-cgal-thumb]');
  let ticking = false;

  function step() {
    const item = track.firstElementChild;
    if (!item) return track.clientWidth;
    const gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
    return item.getBoundingClientRect().width + gap;
  }

  function update() {
    ticking = false;
    const max = track.scrollWidth - track.clientWidth;
    const atStart = track.scrollLeft <= 1;
    const atEnd = track.scrollLeft >= max - 1;

    if (prev) prev.disabled = atStart;
    if (next) next.disabled = atEnd;



    if (thumb) {
      const ratio = track.scrollWidth > 0 ? track.clientWidth / track.scrollWidth : 1;
      thumb.style.width = Math.min(ratio * 100, 100) + '%';
      thumb.style.insetInlineStart = (track.scrollLeft / track.scrollWidth) * 100 + '%';
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  prev?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
  next?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
  track.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  root.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cgal-play]');
    if (!button) return;

    const item = button.closest('.cgal__item');
    if (!item) return;

    const media = item.querySelector('.cgal__media');
    const video = item.querySelector('video');

    if (video) {
      item.classList.add('cgal__item--playing');
      video.setAttribute('controls', '');
      video.play();
      return;
    }

    const id = item.dataset.cgalEmbed;
    const type = item.dataset.cgalType;
    if (!id || !media) return;

    const src =
      type === 'vimeo'
        ? `https://player.vimeo.com/video/${id}?autoplay=1`
        : `https://www.youtube.com/embed/${id}?autoplay=1&rel=0`;

    const frame = document.createElement('iframe');
    frame.src = src;
    frame.allow = 'autoplay; encrypted-media; picture-in-picture';
    frame.allowFullscreen = true;
    frame.title = item.querySelector('.cgal__title')?.textContent || 'Customer video';

    media.appendChild(frame);
    item.classList.add('cgal__item--playing');
  });

  update();
}

function boot(scope) {
  (scope || document).querySelectorAll('[data-cgal]').forEach(initGallery);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => boot());
} else {
  boot();
}

document.addEventListener('shopify:section:load', (e) => boot(e.target));
